import {
  CourseLanguageState,
  CourseLanguageActionTypes,
  COURSE_LANGUAGES_REQUEST,
  COURSE_LANGUAGES_SUCCESS,
  COURSE_LANGUAGES_FAILURE,
} from "./types";

/**
 * Initial state for the course language reducer.
 */
const initialState: CourseLanguageState = {
  courseLanguages: [],
  isLoading: false,
  courseLanguagesLoaded: false,
  error: false,
};

/**
 * Reducer handling course language state changes.
 *
 * Manages course language data, loading state, and error state
 * based on dispatched actions.
 *
 * @param state - Current course language state.
 * @param action - Action dispatched to update the state.
 * @returns Updated state after applying the action.
 */
export const courseLanguageReducer = (
  state = initialState,
  action: CourseLanguageActionTypes
): CourseLanguageState => {
  switch (action.type) {
    case COURSE_LANGUAGES_REQUEST:
      return { ...state, isLoading: true, error: false };
    case COURSE_LANGUAGES_SUCCESS:
      return {
        ...state,
        courseLanguages: action.data,
        isLoading: false,
        courseLanguagesLoaded: true,
        error: false,
      };
    case COURSE_LANGUAGES_FAILURE:
      return { ...state, isLoading: false, error: true };
    default:
      return state;
  }
};
